module.exports = __webpack_public_path__ + "img/swap_horiz_opsz24B.0b26534b.svg";